/** Strings owned by the stream area. */
export const STREAM_STRINGS = {
    // Control column — landmarks
    'stream.device_navigation': { en: 'Device navigation', ru: 'Навигация по устройству' },
    'stream.device_controls': { en: 'Device controls', ru: 'Управление устройством' },
    // Control buttons (title / aria-label)
    'stream.power': { en: 'Power', ru: 'Питание' },
    'stream.copy_device_clipboard': { en: 'Copy device clipboard → you', ru: 'Скопировать буфер устройства → себе' },
    'stream.paste_clipboard_to_device': { en: 'Paste clipboard → device', ru: 'Вставить буфер → на устройство' },
    'stream.screenshot_to_clipboard': { en: 'Screenshot to clipboard', ru: 'Скриншот в буфер обмена' },
    'stream.screenshot': { en: 'Screenshot', ru: 'Скриншот' },
    'stream.download_screenshot': { en: 'Download screenshot', ru: 'Скачать скриншот' },
    'stream.device_info': { en: 'Device info', ru: 'Информация об устройстве' },
    'stream.device_info_last_known': {
        en: 'Device info (last known)',
        ru: 'Информация об устройстве (последние данные)',
    },
    'stream.comment': { en: 'Comment', ru: 'Комментарий' },
    'stream.home': { en: 'Home', ru: 'Домой' },
    'stream.recent_apps': { en: 'Recent apps', ru: 'Недавние приложения' },
    'stream.refresh_screen': { en: 'Refresh screen', ru: 'Обновить экран' },
    'stream.device_screen': { en: 'Device screen', ru: 'Экран устройства' },
    // Clicker group
    'stream.clicker': { en: 'Clicker', ru: 'Кликер' },
    'stream.start_clicker': { en: 'Start clicker', ru: 'Запустить кликер' },
    'stream.stop_clicker': { en: 'Stop clicker', ru: 'Остановить кликер' },
    'stream.clicker_stopping': {
        en: 'Stopping — waiting for the farm to confirm the run is over',
        ru: 'Останавливается — ждём подтверждения от фермы, что прогон завершён',
    },
    // The `&amp;` is kept verbatim: the string lands in an HTML title attribute.
    'stream.reconfigure_restart_clicker': { en: 'Reconfigure &amp; restart clicker', ru: 'Перенастроить и перезапустить кликер' },
    'stream.reconfigure_clicker': { en: 'Reconfigure clicker', ru: 'Перенастроить кликер' },
    'stream.clicker_logs': { en: 'Clicker logs', ru: 'Логи кликера' },
    'stream.operations_registry': { en: 'Operations registry', ru: 'Реестр операций' },
    'stream.clicker_history': { en: 'Clicker history', ru: 'История кликера' },
    'stream.share_links': { en: 'Share links', ru: 'Ссылки доступа' },
    // Connect / disconnect
    'stream.connect': { en: 'Connect', ru: 'Подключить' },
    'stream.disconnect': { en: 'Disconnect', ru: 'Отключить' },
    'stream.not_connected': { en: 'Not connected', ru: 'Не подключено' },
    'stream.device_offline': { en: 'Device is offline', ru: 'Устройство не в сети' },
    'stream.screen_not_loaded': { en: 'Screen not loaded', ru: 'Экран не загружен' },
    // Occupied / co-view
    'stream.in_use': { en: 'In use', ru: 'Занято' },
    'stream.in_use_by': { en: 'In use by {login}', ru: 'Занято: {login}' },
    'stream.force_disconnect': { en: 'Force disconnect', ru: 'Принудительно отключить' },
    'stream.confirm_disconnect_user': { en: 'Disconnect {login} from this device?', ru: 'Отключить {login} от этого устройства?' },
    'stream.watch': { en: 'Watch', ru: 'Смотреть' },
    'stream.stop_watching': { en: 'Stop watching', ru: 'Прекратить просмотр' },
    'stream.watching_readonly': { en: 'Watching (read-only)', ru: 'Просмотр (только чтение)' },
    'stream.watched': { en: 'Watched', ru: 'Наблюдают' },
    'stream.watched_count': { en: 'Watched ({count})', ru: 'Наблюдают ({count})' },
    'stream.watchers_title': { en: 'Read-only co-viewers: {count}', ru: 'Наблюдателей (только чтение): {count}' },
    // Locked states
    'stream.view_only': { en: 'View only', ru: 'Только просмотр' },
    'stream.readonly_clicker_running': { en: 'Read-only — clicker running', ru: 'Только чтение — работает кликер' },
    // Errors
    'stream.screenshot_failed': { en: 'Screenshot failed', ru: 'Не удалось сделать скриншот' },
    'stream.network_error': { en: 'Network error', ru: 'Ошибка сети' },
};
